import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {cartAtom} from 'store';
import {useSetRecoilState} from 'recoil';
import {onCartCompletionRes} from './helper';

const cartCompletion = async (data: CartCompletionReqT) => {
  const {description} = data;
  return axios.post(Routes.CART_COMPLETION, {description});
};

export const useCartCompletion = () => {
  const setCart = useSetRecoilState(cartAtom);

  return useMutation({
    mutationKey: [Keys.CART_COMPLETION_MUT],
    mutationFn: cartCompletion,
    onSuccess: res =>
      onCartCompletionRes({cart: null, setCart, message: res?.data?.message}),
  });
};
